<template>
	<div class="container">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_business-how-pay.title1') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_business-how-pay.text1') }}<br />
						{{ $t('rtr_business-how-pay.text2') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_white"
							@click="$router.push({ name: 'cs' })"
						>
							{{ $t('button.info') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_middle">
				<router-link :to="{ name: 'cs' }" class="link_type_02">
					<p class="text fc_white mr_10">
						{{ $t('rtr_business-how-pay.text3') }}
					</p>
					{{ $t('rtr_business-how-pay.text4')
					}}<span class="CIRCLE_ARROW"></span>
				</router-link>
			</div>
			<div class="sub_bottom">
				<h2 class="title">
					{{ $t('rtr_business-how-pay.title2') }}
				</h2>
				<p class="text">
					{{ $t('rtr_business-how-pay.text5') }}
					{{ $t('rtr_business-how-pay.text6') }}
				</p>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-pay.title3') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_business-how-pay.text7') }}
							</p>
							<router-link
								:to="{ name: '' }"
								class="link_type_02"
								@click="notYet"
							>
								{{ $t('rtr_business-how-pay.text8')
								}}<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/business_pay_02.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/business_pay_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-pay.title4') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_business-how-pay.text9') }}
							</p>
							<router-link
								:to="{ name: '' }"
								class="link_type_02"
								@click="notYet"
							>
								{{ $t('rtr_business-how-pay.text10')
								}}<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="mb_25">
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-pay.title5') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_business-how-pay.text11') }}
							</p>
							<router-link :to="{ name: 'auth-register' }" class="link_type_02">
								{{ $t('rtr_business-how-pay.text12')
								}}<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/business_pay_04.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content2">
				<div class="sub_content">
					<div class="sub_text_area">
						<p class="mb_20">{{ $t('rtr_business-how-pay.text13') }}</p>
						<p class="mb_20">
							{{ $t('rtr_business-how-pay.text14') }}
						</p>
						<p>
							{{ $t('rtr_business-how-pay.text15') }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Pay',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>

<style scoped></style>
